export default {
  // Отмена запросов
  requestAbortControllers: {
    getCheckPrint: null,
  },

  isDev: process.env.NODE_ENV === 'development',
  isDebug: false,

  successfulRequestsAmount: 0,
  isCooldownEnded: false,

  validatorsList: [],

  addressesList: null,
  settedAddressItem: null,

  // Пропы с бекэнда
  order: null,
  form: null,
  additional: null,
  base: null,
  layout: null,
  user: {},

  // Записанное время
  currentDate: {},
  // Ширина формы (меняется при изменении размера окна)
  formWidth: document.documentElement.clientWidth,

  chosenCrmCourier: null,
  advanceCheque: [],
  selectedTemplate: null,
  warningMessageData: {
    title: null,
    body: null,
  },
  orderCreatedMessage: null,

  courierComission: null,
  // Находится ли запрос на создание в статусе pending
  isFormPending: false,
  // Кооректно ли заполнена вся форма
  isFormValid: false,

  services: [],
  defaultServices: [],
  checkedServices: [],

  // Блокируем ли кнопку "Заказать доставку" в форме без реги
  isOrderButtonBlocked: false,

  // Отправляем ли time_due в форме для яндекса
  isSendTimeDue: true,

  // Храним результаты поиска адреса в пределах сессии этой страницы
  // ключами в архиве выступают введенные пользователем адреса
  archiveAddressSuggestions: [],

  monthStrings: [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ],
  manualNarrowInterval: false,
  manualOtherDay: false,
  weightValues: [500, 1000, 3000, 5000, 10000, 15000, 20000, 25000, 50000, 100000, 300000, 1500000],
  deliveryMethods: [
    {
      id: 0,
      isVisible: true,
      name: 'Пешком',
      minWeight: 0,
      weight: 14900,
      icon: 'man',
      icon2: 'onFoot',
    },
    {
      id: 1,
      isVisible: true,
      name: 'Легковое авто',
      minWeight: 0,
      weight: 99000,
      icon: 'car',
      icon2: 'car',
    },
    {
      id: 2,
      isVisible: true,
      name: 'Универсал',
      minWeight: 100000,
      weight: 299000,
      icon: 'hatchback',
      icon2: 'cablook',
    },
    {
      id: 3,
      isVisible: true,
      name: 'Газель',
      minWeight: 300000,
      weight: 1500000,
      icon: 'gazelle',
      icon2: 'heavy',
    },
  ],
  incomeReturnMethods: [
    {
      label: 'Банковская карта',
      value: 0,
      inputPlaceholder: 'Номер карты или телефона',
    },
    {
      label: 'Расчетный счет',
      value: 3,
    },
    {
      label: 'ЮMoney (Я.Деньги)',
      value: 1,
      inputPlaceholder: 'Номер счета',
    },
  ],
  postscripts: {
    storey: 'эт.',
    apartment: 'кв.',
    entrance: 'под.',
  },
  selectedDot: null,
  modals: {
    selectionOnMap: false,
    chooseOrderType: true,
    favouriteCouriers: false,
    templates: false,
    createNewTemplate: false,
    bindNewCard: false,
    warningMessage: false,
    orderCreated: false,
    askCity: false,
    approvePhone: false,
  },
  isExtraDetailsVisible: false,
  nextItemIndex: 1,

  isFormLoading: false,
  isFormFetching: false,
  isShowPaymentMethods: false,

  /**
   * Время "сейчас" у точек
   * ключ - индекс точки
   * @type {Record<string, boolean>}
   */
  isCurrentTime: {},

  // Админка
  fixPriceStatus: 0,
  selectedUser: null,
  phoneCheckStatus: null,
  metroList: {},

  // Форма без регистрации
  // Функция генерации токена.
  tokenGenerator: null,
  currentActiveStep: 0,
  approveUser: {
    isFetching: false,
    isValided: false,
    code: '',
    message: '',
    status: null,
    phoneNumber: '',
    timeLeft: 0,
  },
  appToken: null,
  isHighDemand: false,
  // Нужен для вывода описания причины отклонения промокода. Сейчас не используется
  // promoValuesDescriptions: [
  //   'Корректный код',
  //   'Промокод неактивен, либо израсходован его лимит.',
  //   'Израсходован лимит пользователя на промокод',
  //   'Промокод не найден',
  //   'Промокод доступен только для зарегистрированных пользователей.',
  //   'Промокод доступен только для незарегистрированных пользователей',
  // ],
}
